import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Select from "@material-ui/core/Select";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";

const useStyles = makeStyles((theme) => ({
  bar: {
    position: "sticky",
    bottom: 0,
    zIndex: theme.zIndex.appBar,
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
    padding: theme.spacing(1.5, 2),
    margin: theme.spacing(0, 2, 2, 2),
    borderTop: `3px solid ${theme.palette.primary.main}`,
  },
  count: {
    fontWeight: 600,
  },
  spacer: {
    flex: "1 1 auto",
  },
  format: {
    minWidth: 130,
  },
  hint: {
    color: theme.palette.text.secondary,
  },
}));

const MINIMUM = 2;

function MasterReportBar(props) {
  const {
    selectedCount,
    maximum,
    reportType,
    reportTypes,
    onReportTypeChange,
    onGenerate,
    onClear,
  } = props;
  const classes = useStyles();

  const belowMinimum = selectedCount < MINIMUM;
  const aboveMaximum = selectedCount > maximum;

  // Stated inline rather than only disabling the button, so the reason a
  // selection cannot be combined is never a mystery.
  const makeHint = () => {
    if (belowMinimum) {
      return `Select at least ${MINIMUM} inspections to combine.`;
    }

    if (aboveMaximum) {
      return `Select at most ${maximum} inspections — remove ${
        selectedCount - maximum
      }.`;
    }

    return "Summaries first, then each full report.";
  };

  return (
    <Paper className={classes.bar} elevation={8}>
      <Typography className={classes.count}>
        {selectedCount} selected
      </Typography>
      <Typography variant="body2" className={classes.hint}>
        {makeHint()}
      </Typography>
      <div className={classes.spacer} />
      <FormControl className={classes.format} size="small">
        <InputLabel htmlFor="master-report-format">Format</InputLabel>
        <Select
          native
          id="master-report-format"
          value={reportType}
          onChange={(event) => onReportTypeChange(event.target.value)}
        >
          {reportTypes.map((type) => (
            <option key={type} value={type}>
              {type === "xlsx" ? "Excel" : "PDF"}
            </option>
          ))}
        </Select>
      </FormControl>
      <Button onClick={onClear}>Clear</Button>
      <Button
        variant="contained"
        color="primary"
        disabled={belowMinimum || aboveMaximum}
        onClick={onGenerate}
      >
        Generate Master Report
      </Button>
    </Paper>
  );
}

MasterReportBar.propTypes = {
  selectedCount: PropTypes.number.isRequired,
  maximum: PropTypes.number.isRequired,
  reportType: PropTypes.string.isRequired,
  reportTypes: PropTypes.arrayOf(PropTypes.string).isRequired,
  onReportTypeChange: PropTypes.func.isRequired,
  onGenerate: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
};

export default MasterReportBar;
